<iframe name="contentFrame" [src]=url></iframe>